module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./node_modules/symbol-observable/index.js
// module id = 494
// module chunks = 0